import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';
import template from './index.jade';
import css from './index.styl?inline';

import './settings-li';

export default registerMPElement(
  `mp-settings-section`,
  class extends Component {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        'help-text': {type: `string`, description: `Set to add a help tooltip next to the title.`},
        'help-link-url': {type: `string`, description: `URL for help link`},
        'help-link-text': {type: `string`, description: `Text for help link anchor tag`},
        'tooltip-max-width': {type: `string`, description: `Width of info tooltip`, default: `250px`},
        title: `string`,
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,
      };
    }
  },
);
